// hooks/useIdleTimeout.js
import { useEffect, useRef, useCallback } from "react";

const IDLE_TIMEOUT = 20 * 60 * 1000; // 20 דקות במילישניות

const EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
];

export function useIdleTimeout(onTimeout) {
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(onTimeout, IDLE_TIMEOUT);
  }, [onTimeout]);

  useEffect(() => {
    // התחל טיימר בטעינה
    resetTimer();

    // האזן לאירועי פעילות
    EVENTS.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      clearTimeout(timerRef.current);
      EVENTS.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer]);
}
